import { Job } from './../models/job.model';
import { JobListing, JobListingItem } from './../models/listing.model';
import { Unit } from './../../settings-module/models/unit';
import { SelectedJobState } from '../reducers/jobs.reducer';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import * as fromJobs from '../reducers';
import * as fromRoot from '../../reducers';
import * as jobActions from '../actions/jobs.actions';
import { Component } from '@angular/core';

@Component({
  selector: 'mj-view-job-listing-page',
  template: `
    <mj-job-listing
      [unit]="unit$ | async"
      (onJobChanged)="onJobChange($event)"
      [job]="(jobState$ | async).job"
      [listing]="(jobState$ | async).listing"
    >
    </mj-job-listing>
  `,
})
export class ViewJobListingPageComponent {
  jobState$: Observable<SelectedJobState>;
  unit$: Observable<Unit>;

  constructor(public store: Store<fromJobs.State>) {
    this.jobState$ = this.store.select(fromJobs.getSelectedJob);
    this.unit$ = this.store.select(fromRoot.getSelectedUnit);
  }

  onJobChange($event: {
    job: Job;
    listing?: JobListing;
    changedListingItem?: JobListingItem;
  }) {
    this.store.dispatch(new jobActions.SaveJob($event));
  }
}
